import React from 'react';
import { SectionCard, TextField, TextAreaField, Repeater } from '../../../components/admin/EditorFields';

const ICONS = ['Building2', 'Users', 'Newspaper', 'Heart', 'Mail', 'Phone', 'Briefcase', 'Globe'];

export default function ContactEditor({ data, setData }) {
  const upd = (path, value) => setData((d) => {
    const next = JSON.parse(JSON.stringify(d));
    const keys = path.split('.');
    let cur = next;
    for (let i = 0; i < keys.length - 1; i++) {
      cur[keys[i]] = cur[keys[i]] || {};
      cur = cur[keys[i]];
    }
    cur[keys[keys.length - 1]] = value;
    return next;
  });

  return (
    <div className="space-y-5">
      <SectionCard title="En-tête de la page">
        <TextField label="Eyebrow" value={data.hero?.eyebrow} onChange={(v) => upd('hero.eyebrow', v)} />
        <div className="grid sm:grid-cols-2 gap-3">
          <TextField label="Titre" value={data.hero?.title} onChange={(v) => upd('hero.title', v)} />
          <TextField label="Titre en couleur" value={data.hero?.titleHighlight} onChange={(v) => upd('hero.titleHighlight', v)} />
        </div>
        <TextAreaField label="Description" rows={3} value={data.hero?.description} onChange={(v) => upd('hero.description', v)} />
      </SectionCard>

      <SectionCard title="Canaux de contact" description="Cartes affichant les différents moyens de nous contacter (collectivités, bénévoles, presse...).">
        <Repeater
          items={data.channels}
          onChange={(items) => setData((d) => ({ ...d, channels: items }))}
          newItem={() => ({ icon: 'Mail', title: '', desc: '', email: '' })}
          renderItem={(item, update) => (
            <div className="space-y-3">
              <div className="grid sm:grid-cols-2 gap-3">
                <div>
                  <label className="text-xs font-semibold uppercase tracking-wider text-slate-600 mb-1.5 block">Icône</label>
                  <select value={item.icon || 'Mail'} onChange={(e) => update({ icon: e.target.value })} className="w-full h-11 rounded-xl border border-sky-200 px-3 text-sm">
                    {ICONS.map((i) => <option key={i} value={i}>{i}</option>)}
                  </select>
                </div>
                <TextField label="Titre" value={item.title} onChange={(v) => update({ title: v })} />
              </div>
              <TextAreaField label="Description" rows={2} value={item.desc} onChange={(v) => update({ desc: v })} />
              <TextField label="Email de contact" value={item.email} onChange={(v) => update({ email: v })} />
            </div>
          )}
        />
      </SectionCard>

      <SectionCard title="Bloc « Visite du kiosque »">
        <TextField label="Titre" value={data.visitBlock?.title} onChange={(v) => upd('visitBlock.title', v)} />
        <TextAreaField label="Description" rows={3} value={data.visitBlock?.description} onChange={(v) => upd('visitBlock.description', v)} />
        <div className="grid sm:grid-cols-2 gap-3">
          <TextField label="Libellé du CTA" value={data.visitBlock?.ctaLabel} onChange={(v) => upd('visitBlock.ctaLabel', v)} />
          <TextField label="Email du CTA" value={data.visitBlock?.ctaEmail} onChange={(v) => upd('visitBlock.ctaEmail', v)} />
        </div>
      </SectionCard>
    </div>
  );
}
